import { state } from "./State";

export const setIsLoading = (isLoading: boolean) => {
  state.isLoading = isLoading;
};
